<template>
  <header class="navbar">
    <div class="logo">
      <img src="@/assets/logo.png" alt="赛马物联科技（宁夏）有限公司">
    </div>

    <nav class="site-navigation" aria-label="主导航">
      <router-link class="nav-link" to="/">首页</router-link>

      <template v-for="nav in navs" :key="nav.id">
        <router-link
          v-if="nav.children.length === 0"
          class="nav-link"
          :to="getMenuTarget(nav)"
        >
          {{ nav.name }}
        </router-link>

        <div v-else class="nav-menu-group">
          <router-link class="nav-link nav-link--submenu" :to="getMenuTarget(nav)">
            <span>{{ nav.name }}</span>
            <down-outlined class="nav-link__icon"/>
          </router-link>

          <div class="nav-submenu">
            <router-link
              v-for="child in nav.children"
              :key="child.id"
              class="nav-submenu__link"
              :to="getMenuTarget(child)"
            >
              {{ child.name }}
            </router-link>
          </div>
        </div>
      </template>

      <router-link class="nav-link" to="/about">关于我们</router-link>
    </nav>

    <div class="nav-actions">
      <button
        class="nav-action nav-action--icon"
        type="button"
        aria-label="购物车"
        @click="handleMenuClick"
      >
        <shopping-cart-outlined/>
      </button>
      <a
        class="nav-action nav-action--login"
        href="https://portal.wzcwlw.com/#/login"
        target="view_window"
      >
        注册登录
      </a>
    </div>
  </header>
</template>

<script>
import { DownOutlined, ShoppingCartOutlined } from '@ant-design/icons-vue';
import { navbar } from "@/api/navbar";
import { Constants } from "@/common/constants.js";

export default {
  name: "Navbar",
  components: {
    DownOutlined,
    ShoppingCartOutlined
  },
  data() {
    return {
      navs: []
    }
  },
  created() {
    this.getNavbar()
  },
  methods: {
    async getNavbar() {
      try {
        const response = await navbar({ companyId: Constants.id })
        this.navs = this.normalizeNavs(response.data)
      } catch (error) {
        console.error("get navbar failed:", error)
        this.navs = []
      }
    },
    normalizeNavs(items) {
      if (!Array.isArray(items)) {
        return []
      }

      return items.map((item) => ({
        ...item,
        children: this.normalizeNavs(item.children)
      }))
    },
    getMenuTarget(menu) {
      const query = {
        columnId: menu.id,
        companyId: Constants.id
      }

      if (menu.pid && menu.pid !== '0') {
        query.pid = menu.pid
      }

      return menu.url && menu.url.startsWith('/')
        ? { path: menu.url, query }
        : { name: menu.url, query }
    },
    handleMenuClick() {
      this.$message.config({
        top: '50%'
      })
      this.$message.info('暂未开放,敬请期待!')
    }
  }
}
</script>

<style scoped lang="scss">
.navbar {
  display: flex;
  align-items: stretch;
  min-height: 66px;
  padding: 0 20px;
}

.logo {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  overflow: hidden;
}

.logo img {
  display: block;
  width: 189px;
  height: 66px;
  float: none;
}

.site-navigation {
  display: flex;
  flex: 1 1 auto;
  align-items: stretch;
  min-width: 0;
  overflow-x: auto;
  overflow-y: visible;
  scrollbar-width: none;
}

.site-navigation::-webkit-scrollbar {
  display: none;
}

.nav-link,
.nav-menu-group {
  flex: 0 0 auto;
}

.nav-link {
  display: flex;
  align-items: center;
  min-height: 66px;
  padding: 0 16px;
  color: #fff;
  font-size: 18px;
  font-weight: 300;
  line-height: 1;
  white-space: nowrap;
  transition: background-color 0.2s ease;
}

.nav-link:hover,
.nav-link:focus,
.nav-link.router-link-active {
  color: #fff;
  background-color: rgba(24, 144, 255, 0.82);
  text-decoration: none;
}

.nav-link--submenu {
  gap: 8px;
}

.nav-link__icon {
  font-size: 12px;
}

.nav-menu-group {
  position: relative;
  display: flex;
  align-items: stretch;
}

.nav-submenu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  min-width: 144px;
  padding: 6px 0;
  background: rgba(20, 26, 35, 0.96);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.3);
}

.nav-menu-group:hover .nav-submenu,
.nav-menu-group:focus-within .nav-submenu {
  display: flex;
  flex-direction: column;
}

.nav-submenu__link {
  display: block;
  padding: 10px 16px;
  color: #fff;
  font-size: 16px;
  line-height: 1.4;
  white-space: nowrap;
}

.nav-submenu__link:hover,
.nav-submenu__link:focus,
.nav-submenu__link.router-link-active {
  color: #fff;
  background-color: rgba(24, 144, 255, 0.82);
  text-decoration: none;
}

.nav-actions {
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 14px;
  padding-left: 12px;
}

.nav-action {
  color: #fff;
}

.nav-action--icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  padding: 0;
  color: #f5222d;
  font-size: 28px;
  background: transparent;
  border: 0;
  cursor: pointer;
}

.nav-action--login {
  font-size: 16px;
  white-space: nowrap;
}

.nav-action--login:hover,
.nav-action--login:focus {
  color: #fff;
  text-decoration: underline;
}

@media (max-width: 900px) {
  .navbar {
    padding: 0 12px;
  }

  .logo img {
    width: 150px;
    height: auto;
  }

  .nav-link {
    padding: 0 12px;
    font-size: 16px;
  }

  .nav-actions {
    gap: 8px;
    padding-left: 8px;
  }

  .nav-action--login {
    font-size: 14px;
  }
}
</style>
